import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiSolidCheckCircle, BiSolidXCircle } from "react-icons/bi";
import UploadReport from "./uploadReport";
import TestForPackage from "./testsByPackagePopup";
import { FiInfo } from "react-icons/fi";
import { Pagination } from "react-bootstrap";
import DisclaimerPopup from "./disclaimerPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { FaDownload, FaEdit, FaEye, FaRedoAlt } from 'react-icons/fa';
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import jsPDF from "jspdf";
import tmplLogo from "../images/tmplLogo.png";
import DoctorDisclaimerPopup from "./doctorDisclaimerPopup";
import AdminDashboard from "./admindashboard";
import CancelDoctorAppointment from "./cancelDoctorAppointment";
import RescheduleDoctorAppointment from "./rescheduleDoctorAppointment";
import UploadDoctorApppointmentReport from "./uploadDoctorAppointmentReport";

function ViewDoctorAppointmentsByDoctor() {
  const { userid: paramUserId } = useParams();
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [doctor, setDoctor] = useState(null);

  const navigate = useNavigate();
  const tokenData = JSON.parse(localStorage.getItem("data"));
  const token = tokenData?.token;
  const userRole = tokenData?.role;
  const loggedInUserId = tokenData?.userid; // Assuming "userid" is stored in localStorage

  // Determine which userid to use
  const userid = userRole === 'ROLE_DOCTOR' ? loggedInUserId : paramUserId;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async () => {
    setLoader(true);
    try {
      const searchUrl = `/api/doctor-appointment/doctorId=${doctor.id}`;
      const response = await axios.get(searchUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(response.data);
      // setFilteredData(response.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {

    try {
      setLoader(true);
      const doctorRes = await axios.get(`/api/doctordetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDoctor(doctorRes.data);

      const trans = await axios.get(`/api/doctorappointment/getAllAppointmentsByDoctorId/doctorId=${doctorRes.data?.id}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);

    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
      else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleViewReport = (reportId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const url = `/api/doctor-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDownloadReport = (reportId, fileName) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    axios({
      url: `/api/doctor-appointment-reports/view/${reportId}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "report");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }).catch(() => toast.error("Failed to download report."));
  };

  const handleBack = () => {
    navigate(-1);
  };

  const [loading, setLoading] = useState(null);
  function rsubmit(e, id, status) {
    e.preventDefault();
    setLoading(id);

    const token = JSON.parse(localStorage.getItem("data")).token;

    const entitiesToUpdate = ({
      id: id,
      reportstatus: status,
    });

    axios
      .post(
        "/api/doctorappointment/approve",
        entitiesToUpdate,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        console.log(response.data);
        setLoading(null);
        getData();
      })
      .catch((error) => {
        handleError(error);
      });
  }


  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);

  const handleUploadReport = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsUploadModalOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    setSelectedAppointmentId(null);
    getData();
  };


  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const [showImageModal, setShowImageModal] = useState(false);

  const handleBookApp = () => setShowImageModal(true);
  const handleCloseModal = () => setShowImageModal(false);

  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);

  const handleCancelAppointment = async (appointment) => {
    setSelectedAppointmentId(appointment)
    setIsCancelPopupOpen(true);
  };

  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    setSelectedAppointmentId(null);
    getData();
  };

  const handleAcceptAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      await axios.post(
        "/api/doctorappointment/accept-or-reschedule-or-cancel",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Appointment Confirmed successfully.");
      getData();
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);

    }
  };

  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    setSelectedAppointmentId(null);
    getData();
  };

  return (
    <div>
      {userRole === 'ROLE_DOCTOR' && <AdminDashboard />}

      <div className={`col-12 ${userRole === 'ROLE_DOCTOR' ? 'mx-xl-auto ps-xl-10 mt-10' : ''}`}>

        <div className="d-flex align-items-center justify-content-between mb-2">

          <button className="btn btn-primary" onClick={handleBack}>
            Back
          </button>
          {/* {userRole==='ROLE_SUPER' || userRole==='ROLE_ADMIN' && (
  <button className="btn btn-primary" onClick={handleBookApp}>
    Book Doctor Appointment
  </button>
    )} */}

        </div>
        <div className="card card-raised">
          <div className="card-body">
            <div className="table-responsive">

              <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                    <th>Employee Name</th>
                    <th>Employee Email</th>
                    <th>Employee Contact Number</th>
                    <th>Transaction Date</th>
                    <th>Appointment Date</th>
                    <th>Appointment Status</th>
                    {/* <th>Report Id</th> */}
                    <th>Reports</th>
                    {/* <th>Reciept</th> */}

                  </tr>
                </thead>
                <tbody>
                  {appointmentDetails.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    appointmentDetails.map((appointment, index) => (
                      <tr key={appointment.id}>
                        <td>{index + 1}</td>
                        <td
                          style={{
                            cursor: (
                              appointment.appStatus?.appointmentStatus === 'APPOINTMENT CANCELLED' ||
                              appointment.appStatus?.appointmentStatus === 'APPOINTMENT COMPLETED')
                              ? "default"
                              : "pointer",
                          }}
                          title="Upload Report"
                          onClick={() => {
                            if (
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
                            ) {
                              handleUploadReport(appointment.id);
                            }
                          }}
                          onMouseOver={(e) => {
                            if (
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
                            ) {
                              e.target.style.color = "blue";
                              e.target.style.textDecoration = "underline";
                            }
                          }}
                          onMouseOut={(e) => {
                            e.target.style.color = "";
                            e.target.style.textDecoration = "";
                          }}
                        >
                          {appointment.emplo?.name} {appointment.emplo?.lastname}
                        </td>
                        <td>{appointment.emplo?.email}</td>
                        <td>{appointment.emplo?.phoneno}</td>
                        <td>{appointment.transactionDate}</td>
                        <td>{appointment.appointmentDate}</td>

                        <td>
                          {userRole !== 'ROLE_EMPLOYER' ? (
                            <>
                              <div>{appointment.appStatus?.appointmentStatus}</div>

                              {(appointment.appointmentstatus !== 'APPOINTMENT CANCELLED' &&
                                appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                                appointment.appointmentstatus !== 'APPOINTMENT COMPLETED' &&
                                appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED') && (
                                  <>
                                    {/* Accept and Cancel Buttons */}
                                    <div>
                                      {appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CONFIRMED' &&
                                        (appointment.appStatus?.appointmentStatus === 'APPOINTMENT CONFIRMATION PENDING WITH DOCTOR' ||
                                          appointment.appStatus?.appointmentStatus === 'APPOINTMENT RESCHEDULED') &&
                                        appointment.appStatus?.updatedBy !== 'Doctor' && (
                                          <button
                                            className="btn btn-success btn-sm rounded-pill me-2"
                                            onClick={() => handleAcceptAppointment(appointment.id)}
                                          >
                                            Accept
                                          </button>
                                        )}

                                      <button
                                        className="btn btn-danger btn-sm rounded-pill"
                                        onClick={() => handleCancelAppointment(appointment.id)}
                                      >
                                        Cancel
                                      </button>
                                    </div>

                                    {/* Reschedule Button */}
                                    <div className="mt-2">
                                      <button
                                        className="btn btn-warning btn-sm rounded-pill"
                                        onClick={() => handleRescheduleAppointment(appointment.id)}
                                      >
                                        Reschedule
                                      </button>
                                    </div>
                                  </>
                                )}
                            </>
                          ) : (
                            <div>
                              {appointment.appStatus?.appointmentStatus === 'APPOINTMENT RESCHEDULED' ? (
                                `Appointment Rescheduled on ${appointment.appStatus?.dateTime} by ${appointment.appStatus?.updatedBy}`
                              ) : appointment.appStatus?.appointmentStatus === 'APPOINTMENT CANCELLED' ? (
                                `Appointment Cancelled on ${appointment.appStatus?.dateTime} by ${appointment.appStatus?.updatedBy}`
                              ) : appointment.appStatus?.appointmentStatus === 'APPOINTMENT CONFIRMED' ? (
                                `Appointment Confirmed on ${appointment.appStatus?.dateTime} by ${appointment.appStatus?.updatedBy}`
                              ) : (
                                appointment.appStatus?.appointmentStatus
                              )}
                            </div>
                          )}
                        </td>


                        {/* <td>
                          {(appointment.reports || []).length > 0 ? (
                            <ul className="list-unstyled mb-0">
                              {(appointment.reports || []).map((report) => (
                                <li key={report.id}>{report.id}</li>
                              ))}
                            </ul>
                          ) : "N/A"}
                        </td> */}
                        <td>

                          {appointment.reportstatus ? (

                            <>
                              {(appointment.reports || []).length > 0 ? (
                                <ul className="list-unstyled mb-0">
                                  {(appointment.reports || []).map((report, ri) => (
                                    <li key={report.id} className="d-flex align-items-center justify-content-between mb-1" style={{ gap: '6px' }}>
                                      <span
                                        style={{ cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline', fontSize: '13px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                        onClick={() => handleViewReport(report.id)}
                                        title={report.fileName || `File ${ri + 1}`}
                                      >
                                        {report.fileName || `File ${ri + 1}`}
                                      </span>
                                      <FaDownload
                                        size={14}
                                        style={{ cursor: 'pointer', color: '#198754', flexShrink: 0 }}
                                        title="Download"
                                        onClick={() => handleDownloadReport(report.id, report.fileName)}
                                      />
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <span className="text-muted" style={{ fontSize: '12px' }}>No files</span>
                              )}

                              {(userRole === "ROLE_ADMIN" || userRole === "ROLE_SUPER") && (
                                <FaEdit
                                  className="text-black cursor-pointer mt-1"
                                  size={16}
                                  onClick={() => handleUploadReport(appointment.id)}
                                  title="Modify Report"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </>

                          ) : (
                            "No Report Added"
                          )
                          }
                          <br />
                          <br />

                          {appointment.reportstatus || appointment.orderStatus?.appointmentReport ? (
                            <>
                              {(userRole === "ROLE_ADMIN" || userRole === "ROLE_SUPER") ? (
                                appointment.reportstatus === "REQUESTED" ? (
                                  <>
                                    {appointment.reportstatus} &nbsp;
                                    {loading && (
                                      <div
                                        className="loader"
                                        style={{
                                          position: "relative",
                                          left: "75px",
                                          top: "10px",
                                        }}
                                      ></div>
                                    )}
                                    <BiSolidCheckCircle
                                      className="icon"
                                      id="appointment.reportstatus"
                                      style={{ backgroundColor: "green", cursor: "pointer" }}
                                      value="APPROVED"
                                      title="Approve"
                                      onClick={(e) => rsubmit(e, appointment.id, "APPROVED")}
                                    />
                                    &ensp;
                                    <BiSolidXCircle
                                      className="icon"
                                      value="REJECTED"
                                      style={{ backgroundColor: "red", cursor: "pointer" }}
                                      id="appointment.reportstatus"
                                      title="Reject"
                                      onClick={(e) => rsubmit(e, appointment.id, "REJECTED")}
                                    />
                                  </>
                                ) : (
                                  <>{appointment.reportstatus}</>
                                )
                              ) : (
                                <>{appointment.reportstatus}</>
                              )}
                            </>
                          ) : null}
                        </td>

                        {/* <td 
                            style={{
                              cursor: appointment.paymentId !== null ? "pointer" : "default",
                              textAlign: "center", // Center alignment
                              verticalAlign: "middle", // Vertically align content
                            }} 
                            title={appointment.paymentId !== null ? "Download Receipt" : ""}
                            onClick={() => appointment.paymentId !== null && handleDownloadReciept(appointment)}
                          >
                            {appointment.paymentId !== null ? <FaDownload /> : "NA"}
                          </td> */}

                      </tr>
                    ))
                  )}
                </tbody>
              </table>

            </div>
            <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
          </div>
          {isUploadModalOpen && (
            <UploadDoctorApppointmentReport
              isOpen={isUploadModalOpen}
              onRequestClose={handleCloseUploadModal}
              appointmentId={selectedAppointmentId}
            />
          )}

          {showImageModal && (
            <DoctorDisclaimerPopup isOpen={showImageModal} onRequestClose={handleCloseModal} userid={userid} />
          )}

          {isReschedulePopupOpen && (
            <RescheduleDoctorAppointment
              isOpen={isReschedulePopupOpen}
              onRequestClose={handleCloseReschedulePopup}
              doctorAppointmentId={selectedAppointmentId}
            />
          )}

          {isCancelPopupOpen && (
            <CancelDoctorAppointment
              isOpen={isCancelPopupOpen}
              onRequestClose={handleCloseCancelPopup}
              doctorAppointmentId={selectedAppointmentId}
            />
          )}

          {loader && <div className="loading"></div>}
        </div>
      </div>
    </div>

  );
}

export default ViewDoctorAppointmentsByDoctor;
